<!-- Navigation -->

@if (isScreenSmall) {
  <fuse-vertical-navigation
    class="dark bg-gray-900 print:hidden"
    [mode]="'over'"
    [name]="'mainNavigation'"
    [navigation]="navigation"
    [opened]="false"
    >
    <!-- Navigation header hook -->
    <ng-container fuseVerticalNavigationContentHeader>
      <!-- Logo -->
      <div class="flex items-center h-20 pt-6 px-8">
        <img class="w-24" [src]="logoSrc" alt="Logo image" />
      </div>
    </ng-container>
  </fuse-vertical-navigation>
}

<!-- Wrapper -->
<div class="flex flex-col flex-auto w-full min-w-0">
  <fleet-flex-communication-banner></fleet-flex-communication-banner>
  <fleet-update-banner></fleet-update-banner>
  @if (envName !== 'prod') {
    <fleet-version-banner></fleet-version-banner>
  }
  <!-- Header -->
  <div
    class="relative flex flex-0 items-center w-full h-16 sm:h-20 px-4 md:px-6 z-49 shadow dark:shadow-none dark:border-b bg-card dark:bg-transparent print:hidden"
    >
    @if (!isScreenSmall) {
      <!-- Logo -->
      <!-- <div class="flex items-center mx-2 lg:mr-8">
      <div class="hidden lg:flex">
        <img class="dark:hidden w-24" [src]="logoSrc" />
        <img class="hidden dark:flex w-24" [src]="logoSrc" />
      </div>
      <img class="flex lg:hidden w-8" [src]="logoSrc" />
    </div> -->
    <!-- Horizontal navigation -->
    <fuse-horizontal-navigation
      class="mr-2"
      [name]="'mainNavigation'"
      [navigation]="navigation"
    ></fuse-horizontal-navigation>
  }
  <!-- Navigation toggle button -->
  @if (isScreenSmall) {
    <button mat-icon-button (click)="toggleNavigation('mainNavigation')">
      <mat-icon [svgIcon]="'heroicons_outline:menu'"></mat-icon>
    </button>
  }
  <!-- Components -->
  <div class="flex items-center pl-2 ml-auto space-x-2">
    <!-- NEW JOB BUTTON -->
    @if (fleetProduct === 'HUB' || fleetProduct === 'BUSINESS') {
      <button
        class="bg-primary-600 text-white disabled:bg-gray-200"
        mat-raised-button
        (click)="onNewJobClick()"
        >
        NEW JOB
      </button>
    }
  </div>
</div>

<!-- Content -->
<div class="flex flex-col flex-auto w-full">
  <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
  Otherwise, layout changes won't be registered and the view won't be updated! -->
  @if (true) {
    <router-outlet></router-outlet>
  }
</div>
</div>
